export const MANTENIMIENTO_SERVICES_DATA = [
    {
      slug: "limpieza-interior-profunda",
      title: "Limpieza Interior Profunda",
      description: `Servicio profesional de limpieza interior con herramientas especializadas. 
      Limpiamos a fondo moquetas, asientos y habitáculo completo, incluyendo desinfección. 
      Eliminamos suciedad incrustada, manchas y olores persistentes (tabaco, mascotas). 
      Ideal para recuperar el aspecto original del interior de tu vehículo. 
      
      Precio de lanzamiento: 80€ para los primeros 100 vehículos (precio regular: 120€).`,

      images: [
        "/assets/img/service/limpieza-interior-2.jpg",
        "/assets/img/service/limpieza-interior-1.jpg",
      ],

      checklist: [
        "Limpieza profunda de moquetas y asientos",
        "Desinfección completa del habitáculo",
        "Eliminación de olores persistentes",
        "Recuperación del aspecto original",
        "Duración aproximada: 90 minutos",
        "Precio lanzamiento: 80€ (regular: 120€)",
      ],
    },
    {
      slug: "pulido-faros",
      title: "Pulido de Faros",
      description: `Con el paso del tiempo, los faros suelen opacarse o 
      amarillearse, reduciendo la visibilidad y la estética del vehículo. 
      Mediante un proceso profesional de pulido y aplicación de barniz 
      protector, en LealChapaYPintura.com logramos recuperar la transparencia 
      original de tus faros, mejorando la iluminación y aportando un mayor 
      nivel de seguridad en la conducción nocturna.`,

      checklist: [
        "Eliminación de opacidad y rayaduras",
        "Aplicación de productos protectores UV",
        "Recuperación del brillo original",
        "Mayor alcance lumínico en conducción nocturna",
      ],
    },
    {
      slug: "aceite-y-filtros",
      title: "Cambio de Aceite y Filtros",
      description: `Un correcto mantenimiento del aceite y los filtros es 
      vital para alargar la vida útil del motor y garantizar su rendimiento. 
      Te asesoramos sobre el tipo de aceite adecuado para tu vehículo 
      (sintético, semisintético, etc.) y sustituimos el filtro de aceite, 
      aire y habitáculo según las recomendaciones del fabricante. De esta 
      forma, tu coche siempre estará en las mejores condiciones para 
      responder en cualquier situación.`,
     
      checklist: [
        "Elección de aceite según especificaciones del motor",
        "Reemplazo de filtros con recambios de calidad",
        "Reseteo de indicadores de servicio",
        "Control de niveles y líquidos adicionales",
      ],
    },
    {
      slug: "pastillas-y-discos-de-freno",
      title: "Cambio de Pastillas y Discos de Freno",
      description: `Los frenos son un elemento esencial en la seguridad 
      de tu vehículo. Si notas ruidos, vibraciones o una respuesta más larga 
      al pisar el pedal, es hora de revisar y, posiblemente, cambiar las 
      pastillas y/o los discos de freno. Trabajamos con primeras marcas y 
      ofrecemos un servicio completo de limpieza y engrase, garantizando 
      un frenado eficiente y seguro.`,
 
      checklist: [
        "Instalación de discos y pastillas de marcas reconocidas",
        "Comprobación de pinzas y líquidos de freno",
        "Eliminación de chirridos y vibraciones",
        "Garantía de frenado preciso y efectivo",
      ],
    },
    {
      slug: "cargaac",
      title: "Carga de Aire Acondicionado",
      description: `La climatización del vehículo es fundamental para 
      tu confort, sobre todo en meses de calor intenso. En 
      LealChapaYPintura.com realizamos el servicio de carga de aire 
      acondicionado, revisión de presiones y detección de posibles fugas. 
      Utilizamos gases homologados y respetuosos con el medio ambiente, 
      asegurando un correcto funcionamiento y una larga vida útil del 
      sistema de refrigeración.`,

      checklist: [
        "Recarga con gas certificado",
        "Detección y reparación de fugas",
        "Revisión de compresor y condensador",
        "Temperatura óptima para viajes cómodos",
      ],
    },
  ];
  